module.exports = __webpack_public_path__ + "img/cloud-plus.b13cb36a.svg";